import { render, staticRenderFns } from "./MantleSystemRecommended.vue?vue&type=template&id=80e7247a&scoped=true"
import script from "./MantleSystemRecommended.vue?vue&type=script&lang=js"
export * from "./MantleSystemRecommended.vue?vue&type=script&lang=js"
import style0 from "./MantleSystemRecommended.vue?vue&type=style&index=0&id=80e7247a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e7247a",
  null
  
)

export default component.exports